import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Header';
import Homepage from './Homepage';
import ChiSiamo from './ChiSiamo';
import Servizi from './Servizi';
import Contatti from './Contatti';
import Footer from './Footer';

function App() {
  return (
      <Router>
        <div className="app-container">
          <Header />
          <div className="main-content">
            <Routes>
              <Route exact path="/" element={<Homepage />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/contatti" element={<Contatti />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
  );
}

export default App;
